import { useRef } from 'react';
import { List } from 'react-virtualized';

import { User } from '@/types/userList';
import { useCalcRowHeight } from './useCalcRowHeight';
import { useRecomputeRowHeights } from './useRecomputeRowHeights';

export const useVirtualizedList = (
  isPreview: boolean,
  selectedUserId: number | null,
  users: User[],
) => {
  // react-virtualized のリストのリファレンスを保持
  const listRef = useRef<List>(null);

  const { recomputeRowHeights } = useRecomputeRowHeights(listRef);
  const { calcRowHeight } = useCalcRowHeight(isPreview, selectedUserId, users);

  return {
    calcRowHeight,
    listRef,
    recomputeRowHeights,
  };
};
